import { render, staticRenderFns } from "./veStuScholarship.vue?vue&type=template&id=5775ccdf&scoped=true"
import script from "./veStuScholarship.vue?vue&type=script&lang=js"
export * from "./veStuScholarship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775ccdf",
  null
  
)

export default component.exports